<div class="container">
    <ion-icon src="./assets/icon/Warning.1.svg"></ion-icon>
    <ion-label>{{message}}</ion-label>
</div>
